import EmojiReactionPopover from '@/components/shared/EmojiReactionPopover'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'

export default function UserChatBubbleFloatingMenus({
  moreMenuAnchor,
  setMoreMenuAnchor,
  moreActionsMenuItems,
  handleMoreMenuItemSelect,
  onReaction,
  reactionPickerAnchorEl,
  setReactionPickerAnchorEl,
  handleReaction,
}) {
  return (
    <>
      <FloatingMenuPopup
        open={Boolean(moreMenuAnchor)}
        anchorEl={moreMenuAnchor}
        onClose={() => setMoreMenuAnchor(null)}
        items={moreActionsMenuItems}
        onItemSelect={handleMoreMenuItemSelect}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        menuListId="user-message-more-actions"
        menuListAriaLabel="Message actions"
        reserveIconSpace
      />
      {onReaction ? (
        <EmojiReactionPopover
          open={Boolean(reactionPickerAnchorEl)}
          anchorEl={reactionPickerAnchorEl}
          onClose={() => setReactionPickerAnchorEl(null)}
          onEmojiSelect={handleReaction}
        />
      ) : null}
    </>
  )
}
